"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsTab = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const router_1 = require("client/components/router");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const edit_inventory_1 = require("../../components/edit-inventory");
const store_2 = require("../../store");
// C-046.101
const Grid_1 = require("@material-ui/core/Grid");
const throttle_debounce_1 = require("throttle-debounce"); // C-046.17 // Sarvesh
const store_3 = require("../../../../../../modules/inventory-order/store"); // C-046.17 // Sarvesh
const purchase_order_1 = require("shared/purchase-order"); //C-046.13 // Sarvesh
const moment = require("moment"); // lavk2 C-046
const PRX = "Claims"; // C-046.39 C-046.16112
const PO = "Orders";
const CI = "Inventory";
const AF = "Formulary";
let DetailsTab = class DetailsTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.confirmDeleteInventory = null;
        this.isDisableErr = false; // B-063.131
        // C-046.10
        this.orderHistory = [];
        this.orderSiteId = 0;
        this.filterText = "";
        this.order = "DESC";
        this.orderBy = "id";
        this.isWarningPopUp = false;
        this.inventoryOrders = [];
        this.currentUrl = window.location.href; // C-046.101
        this.loadPurchaseOrders = throttle_debounce_1.debounce(200, async (tmpSearch = false) => {
            this.orderHistory = await store_3.inventoryOrderStore.loadPurchaseOrders({
                count: 1000,
                // order: this.order,
                search: this.filterText,
                siteId: null,
                start: 0,
            });
        });
        this.initialLoad = async () => {
            await store_2.inventoryDetailStore.loadICD10s();
            const [siteIdFromParams, inventoryId] = this.props.params;
            const siteId = store_1.usersStore.user.value.siteUser
                ? store_1.usersStore.user.value.site.id
                : siteIdFromParams;
            if (inventoryId) {
                console.count("about to read inventory from details.tsx");
                await store_2.inventoryDetailStore.readInventory(Number(inventoryId), Number(siteId));
            }
        };
        this.handleCancel = () => {
            router_1.RouteManager.transitionTo("/formulary");
        };
        this.handleDeleteInventory = (inventory) => {
            this.confirmDeleteInventory = inventory;
        };
        this.onHandleClickConfirmDeleteInventory = async () => {
            this.isDisableErr = true; // C-046.11
            const res = await store_2.inventoryDetailStore.readClaimUnresolvedInventory(this.confirmDeleteInventory);
            if (this.confirmDeleteInventory && res && this.isWarningPopUp) {
                const success = await store_2.inventoryDetailStore.deleteInventory(this.confirmDeleteInventory);
                // B-063.131
                if (store_2.inventoryDetailStore.inventory.error) {
                    this.confirmDeleteInventory = store_2.inventoryDetailStore.inventory;
                    this.isDisableErr = true; // B-063.131
                    this.isWarningPopUp = false;
                }
                if (success) {
                    router_1.RouteManager.transitionTo("/formulary");
                }
                this.confirmDeleteInventory = null;
            }
        };
        // C-046.11
        this.onHandleClickConfirmEnablenventory = async () => {
            if (this.confirmDeleteInventory) {
                const success = await store_2.inventoryDetailStore.enableInventory(this.confirmDeleteInventory);
                if (success) {
                    router_1.RouteManager.transitionTo("/formulary");
                }
                this.confirmDeleteInventory = null;
            }
        };
        this.onHandleClickCancelDeleteInventory = () => {
            this.confirmDeleteInventory = null;
        };
        // B-063.131
        this.handleWarningClose = () => {
            this.confirmDeleteInventory = null; // C-046.10
            this.isDisableErr = false; // C-046.10
        };
        this.handleSave = async (inventory) => {
            //E-086
            store_2.inventoryDetailStore.setActionLogs(false, []);
            store_2.inventoryDetailStore.saveInventory(inventory);
            await this.initialLoad();
        };
        // C-046.101
        this.selectcls = {
            padding: 8,
            marginBottom: 15,
            width: "100%",
            border: "1px solid #c7c7c7",
            borderRadius: 4,
            font: "400 14px Heebo",
            textAlign: "center",
        };
        this.optioncss = {
            font: "400 14px Heebo",
            textAlign: "start",
        };
        // C-046.10
        this.handleDropdownClick = (e, type, data) => {
            e.persist();
            const { value: url } = e.target;
            let getLength = url.replace(/.*\(|\).*/g, "");
            let transID = url.slice(10, -getLength.length - 2);
            if (url === "Please select")
                return;
            window.open(type === PRX // C-046.39
                ? `/claims/${url} `
                : type === CI
                    ? `/lots/pharmacies/${url}/inventory-lot`
                    : `/order/review/${transID}`, "_blank");
        };
        // C-046.101
        this.goToActiveSite = () => {
            router_1.RouteManager.transitionTo(`${this.currentUrl}/pharmacies`);
        };
        this.renderOrderInventory = (data, type) => {
            const isDisabled = data <= 0 ? true : false;
            const btnAFcls = {
                width: "100%",
                background: `white`,
                marginBottom: 15,
                color: `${isDisabled ? "#a1a1a1" : "black"}`,
                padding: 8,
                border: `1px solid #d8d8d8`,
                borderRadius: 4,
                font: "400 14px Heebo",
                cursor: `${isDisabled ? "default" : "pointer"}`,
            };
            return (React.createElement(React.Fragment, null,
                React.createElement(Grid_1.default, { container: true, justifycontent: "center", style: { textAlign: "left" }, alignitems: "center", spacing: 1 },
                    React.createElement(Grid_1.default, { item: true, xs: 5 },
                        React.createElement("label", { style: this.optioncss },
                            type,
                            " ")),
                    React.createElement(Grid_1.default, { item: true, xs: 7 }, type === AF ? (React.createElement("button", { onClick: this.goToActiveSite, disabled: data <= 0 ? true : false, style: btnAFcls }, `${data > 0 ? `Pharmacies (${data})` : "No Pharmacies"} `)) : (React.createElement("select", { disabled: !(data === null || data === void 0 ? void 0 : data.length), style: this.selectcls, onChange: (e) => this.handleDropdownClick(e, type, data) },
                        React.createElement("option", { value: "Please select" }, type === PRX && (data === null || data === void 0 ? void 0 : data.length)
                            ? `${PRX} (${data === null || data === void 0 ? void 0 : data.length})`
                            : type === PO && (data === null || data === void 0 ? void 0 : data.length)
                                ? `${PO} (${data === null || data === void 0 ? void 0 : data.length})`
                                : type === PO && !(data === null || data === void 0 ? void 0 : data.length)
                                    ? `No ${PO}`
                                    : type === CI && (data === null || data === void 0 ? void 0 : data.length)
                                        ? `${CI} (${data === null || data === void 0 ? void 0 : data.length})`
                                        : type === CI && !(data === null || data === void 0 ? void 0 : data.length)
                                            ? `No ${CI}`
                                            : type === AF && (data === null || data === void 0 ? void 0 : data.length)
                                                ? `Pharmacies (${data === null || data === void 0 ? void 0 : data.length})`
                                                : type === AF && !(data === null || data === void 0 ? void 0 : data.length)
                                                    ? "No Pharmacies"
                                                    : `No ${PRX}`), data === null || data === void 0 ? void 0 :
                        data.map((elm) => (React.createElement("option", { key: type === CI ? elm.siteId : elm, value: type === CI ? elm.siteId : type === PRX ? elm.orderId : elm }, type === PRX
                            ? `Rx ${elm.rxId}`
                            : type == CI
                                ? `${elm.displayName} - ( QTY:${elm.qty})`
                                : elm)))))))));
        };
    }
    async componentDidMount() {
        await this.loadPurchaseOrders(); // C-046.10
        await this.initialLoad();
    }
    // C-046.10
    isArrEmpty(array) {
        return (Array.isArray(array) && array.length === 0) || array === 0
            ? true
            : false || array === undefined
                ? true
                : false;
    }
    render() {
        var _a;
        // C-046.101 start
        const { inventory: { value }, } = store_2.inventoryDetailStore; // C-046.11
        const { error, unresolved } = store_2.inventoryDetailStore.inventory; // C-046.11 // C-046.10
        const activeInventorySites = value === null || value === void 0 ? void 0 : value.sites.filter((item) => { var _a; return (_a = item.site) === null || _a === void 0 ? void 0 : _a.live; }).length; // C-046.101
        const [siteIdFromParams, inventoryId] = this.props.params;
        const { purchaseOrders } = store_3.inventoryOrderStore;
        this.inventoryOrders = purchaseOrders
            .map((iOrders) => {
            const { site, orderInventories, shippingMethods, user } = iOrders, restOrderInventory = __rest(iOrders, ["site", "orderInventories", "shippingMethods", "user"]);
            return Object.assign(Object.assign({}, iOrders.orderInventories[0]), { orderInventory: restOrderInventory });
        }) // C-046.13 // Sarvesh
            .filter((val) => {
            if (val.inventoryId === Number(inventoryId)) {
                const { orderInventory } = val;
                const hasProductReceivedZero = orderInventory.purchaseOrderDistributorInvoices.some((invoice) => invoice.productReceived === 0);
                if (orderInventory.approvalStatus === purchase_order_1.POStatus.Pending) {
                    return true;
                }
                else if (orderInventory.approvalStatus === purchase_order_1.POStatus.Approved) {
                    return hasProductReceivedZero;
                }
            }
            return false; // Exclude all other cases
        });
        // lavk2 C-046 2025-03-26 23:39:58 new chnages here
        let currentdate = moment(new Date()).format("YYYY/MM/DD");
        const transformedCurrentInvent = (_a = value === null || value === void 0 ? void 0 : value.sites) === null || _a === void 0 ? void 0 : _a.filter((val) => {
            var _a;
            return val.active === 1 &&
                val.site &&
                val.quantity > 0 &&
                // moment(val.inventorySiteLots[0]?.expirationDate).isSameOrAfter(currentdate, 'day') // Check expiration date
                moment((_a = val.inventorySiteLots) === null || _a === void 0 ? void 0 : _a.expirationDate).isSameOrAfter(currentdate, 'day');
        } // Check expiration date
        ).map((val) => {
            var _a;
            return ({
                siteId: val.siteId,
                displayName: ((_a = val.site) === null || _a === void 0 ? void 0 : _a.displayName) || "",
                qty: val.quantity
            });
        }).sort((a, b) => a.displayName.localeCompare(b.displayName)); // Use localeCompare for string comparison
        const pendingApproval = this.inventoryOrders.map((val) => `TRANS ID: ${val.orderInventory.id}  (${val.orderInventory.pharmacyName})`);
        console.log("activeInventorySites", {
            unresolved,
            activeInventorySites,
            pendingApproval,
            transformedCurrentInvent,
        });
        this.isWarningPopUp =
            this.isArrEmpty(activeInventorySites) &&
                this.isArrEmpty(transformedCurrentInvent) &&
                this.isArrEmpty(pendingApproval);
        // C-046.101 end
        return (React.createElement("div", { className: "inventory-detail__form" },
            React.createElement(edit_inventory_1.EditInventory, { params: this.props.params, error: "", inventory: store_2.inventoryDetailStore.inventory.value, status: store_2.inventoryDetailStore.inventory.status, onCancel: this.handleCancel, onSave: this.handleSave, onDelete: this.handleDeleteInventory }),
            this.confirmDeleteInventory && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: value.deletedAt === null ? "Disable" : "Enable", cancelText: "Cancel", message: `Are you sure you want to ${value.deletedAt === null ? "disable" : "enable"} ${(value === null || value === void 0 ? void 0 : value.strengthDescription) === ""
                    ? value.name
                    : value === null || value === void 0 ? void 0 : value.strengthDescription}?<br />`, onCancel: this.onHandleClickCancelDeleteInventory, onConfirm: value.deletedAt === null
                    ? this.onHandleClickConfirmDeleteInventory
                    : this.onHandleClickConfirmEnablenventory, title: value.deletedAt === null
                    ? "Disable Confirmation"
                    : "Enable Confirmation" })),
            this.isDisableErr && !this.isWarningPopUp && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Cancel", 
                // cancelText={""} // C-046.15
                message: "", unresolved: error && unresolved, onCancel: this.handleWarningClose, onConfirm: this.handleWarningClose, title: "Warning", desc: `The below listed items are required to be addressed before you are able to disable  ${(value === null || value === void 0 ? void 0 : value.strengthDescription) === ""
                    ? value.name
                    : value === null || value === void 0 ? void 0 : value.strengthDescription} `, pendingOrders: this.renderOrderInventory(unresolved, PRX), pendingApprovalOrder: this.renderOrderInventory(pendingApproval, PO), currentInventories: this.renderOrderInventory(transformedCurrentInvent, CI), activeInventories: this.renderOrderInventory([activeInventorySites], AF) }))));
    }
};
__decorate([
    mobx_1.observable
], DetailsTab.prototype, "confirmDeleteInventory", void 0);
__decorate([
    mobx_1.observable
], DetailsTab.prototype, "isDisableErr", void 0);
__decorate([
    mobx_1.observable
], DetailsTab.prototype, "orderHistory", void 0);
__decorate([
    mobx_1.observable
], DetailsTab.prototype, "orderSiteId", void 0);
__decorate([
    mobx_1.observable
], DetailsTab.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], DetailsTab.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], DetailsTab.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], DetailsTab.prototype, "currentUrl", void 0);
DetailsTab = __decorate([
    mobx_react_1.observer
], DetailsTab);
exports.DetailsTab = DetailsTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-detail/tabs/details/details.tsx
// module id = 3467
// module chunks = 0